export enum CounterDataViewMode {
  DoubleIndex,
  SingleIndex,
  SparseIndex
}
